import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    searchComponent: {
        display: "flex",
        flexDirection: "row-reverse",
        fontSize: 14,
        position: "relative",
        alignItems: "center",
        height: 18,

        '& svg path': {
            fill: theme.palette.secondary.main
        },
        '&:before': {
            left: 0,
            bottom: 0,
            right: 0,
            content: '""',  // !!! обязательно указать снаружи одинарные кавычки !!!
            position: "absolute",
            pointerEvents: "none",
            borderBottom: `1px solid ${theme.palette.secondary.main}`,
        },
        '&:hover:not(.Mui-disabled, .Mui-error):before': {
            borderColor: theme.palette.mainButton.blue,
            borderWidth: 2,

        },
        '&:hover:not(.Mui-disabled, .Mui-error)': {
            '& svg path': {
                fill: theme.palette.mainButton.blue
            }
        },

        "@media screen and (max-width: 768px)": {
          margin: "0!important"
        }

    },
    searchComponentActive: {
        '&:before': {
            left: 0,
            bottom: 0,
            right: 0,
            content: '""',  // !!! обязательно указать снаружи одинарные кавычки !!!
            position: "absolute",
            pointerEvents: "none",
            borderBottom: `1px solid ${theme.palette.mainButton.blue}`,
        },
        '& svg path': {
            fill: theme.palette.mainButton.blue
        }
    },
    searchIconWrapper: {
        transform: "translateY(4px)",

        "@media screen and (max-width: 768px)": {
            '& svg': {
                width: 22,
                height: 16
            }
        }
    },
    searchInput: {
        fontSize: 14,
        height: 18
    }
}));

export default useStyles;
